// 统一请求路径前缀在libs/axios.js中修改
import {
  doPostRequest,
  postDataRequest,
  getusrdataRequest,
  saveusrDataRequest,
  getRequest2,
  getphoneRequest,
  deletePRequest,
  deleteMideaRequest,
  getRequest4,
  getRequest3,
  showmideaRequest,
  saveDataRequest_audit,
  showDataRequest,
  saveDataRequest,
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
  importRequest,
  uploadFileRequest,
  postRequestpdfORimg,
  getDataRequest,
} from '@/utils/axios';
export const DirectoryTree = params => {
  return getRequest('/catalogSet/getCatalogDir', params);
};
export const Directoryrole = params => {
  return getRequest('/role/getAllList', params);
};
export const DirectoryinsertCatalogSet = params => {
  return postRequest('/catalogSet/insertCatalogSet', params);
};

export const DirectorydeleteCatalogData = params => {
  return deleteRequest('/catalogSet/deleteCatalogSet', params);
};
export const DirectoryUpdateTree = params => {
  return postRequest('/catalogSet/updateCatalogSet', params);
};
export const DirectoryTable = params => {
  return getRequest('/catalogSet/findCatalogSetPage', params);
};
export const FileHookFolder = params => {
  return postRequest('/catalogSet/resourceHook', params);
};
export const DirectoreResourTable = params => {
  return getRequest('/catalogSet/findCatalogSetAndResourcePage', params);
};
export const getByType = params => {
  return getRequest(`/dictData/getByType/${params}`);
};
export const geoserverPublishTiffData = params => {
  return postRequest(`/layer/geoserverPublishTiffData`, params);
};
// 删除文件的接口
export const deleteCatalogData = params => {
  return deleteRequest('/catalogData/deleteCatalogData', params);
};
export const metaDatadeleteAll = params => {
  return deleteRequest(`/metaData/delByIds/${params}`);
};
export const previewFile = params => {
  return getRequest(`/upload/previewFile`, params);
};
export const downLoad = params => {
  return postRequestpdfORimg('/upload/downLoad', params);
};

export const insertCatalogData = params => {
  return postRequest('/catalogData/insertCatalogData', params);
};
export const findWfsById = params => {
  return getRequest('/catalogSet/findWfsById', params);
};
export const updateById = params => {
  return postRequest('/metaData/updateById', params);
};

// 更改文件的别名的接口
export const updateCatalogSetName = params => {
  return postRequest('/catalogData/updateCatalogData', params);
};

// 获取服务的数据 GET GET http://localhost:8899/zituSpace/metaData/getMetaDataList
export const getServerList = params => {
  return getRequest('/metaData/getMetaDataList', params);
};
// 新增服务的接口  POST http://localhost:8899/zituSpace/metaData/insert
export const postInsetLayer = params => {
  return postRequest('/metaData/insert', params);
};
// 删除服务的接口  DELETE http://localhost:8899/zituSpace/metaData/deleteAll/{{ids}}
export const deleteLayer = params => {
  return deleteRequest(`/metaData/deleteAll/${params.ids}`);
};
// 挂接服务  POST http://localhost:8899/zituSpace/catalogSet/serviceHook
// String serviceId, String[] setId
export const postInServiceHook = params => {
  return postRequest('/catalogSet/serviceHook', params);
};

// 目录树的工具箱中投影转换工具请求坐标系列表的接口
export const postToolAllCoordinates = () => {
  return postRequest('/transformation/findAllEPSG');
};

// 批量删除服务的接口
export const deleteBatch = ids => {
  return deleteRequest(`/metaData/deleteAll/${ids}`);
};

// 服务资源禁用服务的接口
export const stopService = params => {
  return postRequest('/common/disableLayer', params);
};
// 开启服务的接口
export const startService = params => {
  return postRequest('/common/enableLayer', params);
};

// 服务共享和取消共享的那个接口
export const shareService = params => {
  return postRequest('/metaData/serverShare', params);
};

// 挂接的时候刚显示挂接弹框的时候右侧的列表显示这条记录挂接过的文件夹
export const allCopyList = params => {
  return getRequest('/catalogSet/getAllHookData', params);
};

// 资源统计的接口
export const getsourceStatistics = params => {
  return getRequest('/catalogSet/resourceSta', params);
};

// 下载样式的接口
export const downLoadMyStyle = params => {
  return postRequestpdfORimg('/style/downloadFileIcon', params);
};

//首页 - 侧边栏 - 提取模块----------------------------------------------------
// 保存方案 /zituSpace/extraction/addExtraction
export const addExtraction = params => {
  return postRequest('/extraction/addExtraction', params);
};

// 编辑方案  /zituSpace/extraction/updateExtraction
export const updateExtraction = params => {
  return postRequest('/extraction/updateExtraction', params);
};

// 获取方案列表 /zituSpace/extraction/findExtractionPage
export const findExtractionPage = params => {
  return getRequest('/extraction/findExtractionPage', params);
};

// 根据id获取详情 /zituSpace/extraction/getExtractionById
export const getExtractionById = params => {
  return getRequest('/extraction/getExtractionById', params);
};

//根据id删除 /deleteExtractionById/id
export const deleteExtractionById = id => {
  return deleteRequest(`/extraction/deleteExtractionById/${id}`);
};

//根据id提取  /zituSpace/extraction/extract
export const extract = params => {
  return getDataRequest('/extraction/extract', params);
};
// http://localhost:8899/zituSpace/postGISSta/nearAnalysis 临近分析
export const nearAnalysis = params => {
  return postRequest('/postGISSta/nearAnalysis', params);
};



// WEBPACK FOOTER //
// ./src/api/CatalogSet.js